// extracted by mini-css-extract-plugin
export var connect = "mailing-list-banner-module--connect--4eceb";
export var container = "mailing-list-banner-module--container--4b993";
export var subscribe = "mailing-list-banner-module--subscribe--adfe8";
export var title = "mailing-list-banner-module--title--ae1af";